import { render, staticRenderFns } from "./buy-now-confirmation.vue?vue&type=template&id=25a68322&scoped=true&"
import script from "./buy-now-confirmation.vue?vue&type=script&lang=js&"
export * from "./buy-now-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./buy-now-confirmation.vue?vue&type=style&index=0&id=25a68322&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a68322",
  null
  
)

export default component.exports